__turbopack_context__.v({
  "bar": "ProductRating-module-scss-module__1GayJW__bar",
  "bar__empty": "ProductRating-module-scss-module__1GayJW__bar__empty",
  "bar__filled": "ProductRating-module-scss-module__1GayJW__bar__filled",
  "rating": "ProductRating-module-scss-module__1GayJW__rating",
  "rating--link": "ProductRating-module-scss-module__1GayJW__rating--link",
  "rating__text": "ProductRating-module-scss-module__1GayJW__rating__text",
  "rating__value": "ProductRating-module-scss-module__1GayJW__rating__value",
});
